// extracted by mini-css-extract-plugin
export var box = "_4g-1";
export var checkboxRow = "_4g-8";
export var checked = "_4g-2";
export var descriptionSpacer = "_4g-a";
export var disabled = "_4g-3";
export var icon = "_4g-6";
export var input = "_4g-0";
export var labelSpacer = "_4g-9";
export var medium = "_4g-5";
export var small = "_4g-4";
export var text = "_4g-7";